import {
  Stepper,
  StepperDivider,
  StepperHighlight,
  StepperItem,
} from "@babackapp/customer-ui/components/stepper";
import { InfoIcon, SettingsIcon, WalletIcon } from "lucide-react";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

// The article selection is not a step here: its route never renders this bar
// (`group` only matches under `line-item/:lineItemId`), so it could only ever
// show as already past. Dropping it leaves room on the row for the widget chrome.
const STEPS = [
  {
    route: "reason",
    label: "reason",
    icon: InfoIcon,
    after: ["resolution", "product-selection", "resolution-options"],
  },
  {
    route: "resolution",
    label: "resolution",
    icon: WalletIcon,
    after: ["product-selection", "resolution-options"],
  },
  {
    route: "resolution-options",
    label: "options",
    icon: SettingsIcon,
    after: [],
  },
] as const;

// The catalog picker has its own route but belongs to the options step.
const ROUTE_ALIASES: Record<string, string> = {
  "product-selection": "resolution-options",
};

export function LineItemStepper() {
  const { pathname } = useLocation();
  const { t } = useTranslation("return-widget-v3");
  const route = pathname.split("/").pop()!;
  const current = ROUTE_ALIASES[route] ?? route;

  return (
    <Stepper>
      {STEPS.map(({ route: step, label, icon: Icon, after }, index) => {
        const isPresent = current === step;

        return (
          <Fragment key={step}>
            {index > 0 && <StepperDivider />}
            <StepperItem
              state={
                isPresent
                  ? "present"
                  : after.includes(route as never)
                    ? "past"
                    : "future"
              }
              style={{ cursor: "default" }}
            >
              {isPresent && <StepperHighlight />}
              <Icon />
              <span className={isPresent ? undefined : "hidden @[300px]:inline"}>
                {t(`lineItem.stepper.${label}`)}
              </span>
            </StepperItem>
          </Fragment>
        );
      })}
    </Stepper>
  );
}
